import { UserLine } from "@/components/people"
import { useEnsureUsers, useUsers } from "@/hooks"
import { NoAnswer } from "./NoAnswer"
import type { IAnswerProps } from "./types"

export function AnswerUser({ answer }: IAnswerProps) {
  const userId = `${answer?.value}`
  useEnsureUsers([userId])
  const { findUser } = useUsers()
  const user = findUser(userId)
  if (!user) return <NoAnswer />

  return <UserLine compact user={user} />
}
